export default {
    mutateExternalagriDropdown ({ commit }, payload) {
        commit('mutateExternalagriDropdown', payload)
    },
    localizeExternalagriDropdown ({ commit }, payload) {
        commit('localizeExternalagriDropdown', payload)
    },
    mutateAgriResearchDropdown ({ commit }, payload) {
        commit('mutateAgriResearchDropdown', payload)
    },
    mutateSeedsFertilizerDropdown ({ commit }, payload) {
        commit('mutateSeedsFertilizerDropdown', payload)
    },
    mutateTrainDropdown ({ commit }, payload) {
        commit('mutateTrainDropdown', payload)
    },
    mutateCommonDropdown ({ commit }, payload) {
        commit('mutateCommonDropdown', payload)
    },
    localizeTrainDropdown ({ commit }, payload) {
        commit('localizeTrainDropdown', payload)
    },
    localizeAgriResearchDropdown ({ commit }, payload) {
        commit('localizeAgriResearchDropdown', payload)
    },
    localizeSeedsFertilizerDropdown ({ commit }, payload) {
        commit('localizeSeedsFertilizerDropdown', payload)
    },
    localizeCommonDropdown ({ commit }, payload) {
        commit('localizeCommonDropdown', payload)
    },
    mutatePortalLoad ({ commit }, payload) {
        commit('mutatePortalLoad', payload)
    },
    mutateHeader ({ commit }, payload) {
        commit('mutateHeader', payload)
    },
    mutateFooter ({ commit }, payload) {
        commit('mutateFooter', payload)
    },
    mutateServiceData ({ commit }, payload) {
        commit('mutateServiceData', payload)
    },
    mutateCustomerTypeList ({ commit }, payload) {
        commit('mutateCustomerTypeList', payload)
    },
    mutateServiceList ({ commit }, payload) {
        commit('mutateServiceList', payload)
    },
    mutateSearch ({ commit }, payload) {
        commit('mutateSearch', payload)
    },
    mutateOrgList ({ commit }, payload) {
        commit('mutateOrgList', payload)
    },
    mutateCategoryList ({ commit }, payload) {
        commit('mutateCategoryList', payload)
    },
    mutateFaqList ({ commit }, payload) {
        commit('mutateFaqList', payload)
    },
    mutateNoticeList ({ commit }, payload) {
        commit('mutateNoticeList', payload)
    },
    mutateNewsList ({ commit }, payload) {
        commit('mutateNewsList', payload)
    },
    setServiceUrl ({ commit }, payload) {
        commit('setServiceUrl', payload)
    }
}
